import React from 'react';
import { Card, Loader } from 'semantic-ui-react';
import { arrayOf, bool, shape } from 'prop-types';

const Feed = ({ items, loading }) =>
  loading ? <Loader active /> : <Card.Group centered items={items} />;

Feed.propTypes = {
  items: arrayOf(shape),
  loading: bool.isRequired,
};
Feed.defaultProps = {
  items: [],
};

export default Feed;



// WEBPACK FOOTER //
// ./src/components/Feed.jsx